import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNGConfig } from 'primeng/api';
import { lastValueFrom } from 'rxjs';

@Injectable()
export class LanguageService {
    public langIsLoaded: boolean = false;
    constructor(private _primengConfig: PrimeNGConfig, private _translate: TranslateService) {
        this.langIsLoaded = false;
    };

    public async loadCurrentLanguage(aCurrentLanguage) {
        let wRes: any;
        if (this.langIsLoaded === false) {
            this._translate.setDefaultLang(aCurrentLanguage);
            this._translate.get('primeng').subscribe(res => {
                this._primengConfig.setTranslation(res);
            });
            wRes = await lastValueFrom(this._translate.getTranslation(aCurrentLanguage));
            this.langIsLoaded = true;
        }
    }

}
